import React, { useEffect } from "react";

import { useModalDataStore } from "../../store/modalData";
import VcaSearchClient from "../modals/vcaSearchClient";
import BhvmTickets from "../modals/bhvmTickets";
import LocationSearch from "../modals/locationSearch";

interface Props {}

const Modal: React.FC<Props> = () => {
    const modalData = useModalDataStore<any>((s) => s.modalData);
    const setModalData = useModalDataStore<any>((s) => s.setModalData);

    let template;

    modalData?.type === "location search" ? (template = <LocationSearch />) : modalData?.type === "vca search client" ? (template = <VcaSearchClient />) : modalData?.type === "bhvm tickets" ? (template = <BhvmTickets />) : (template = "");
    return (
        <>
            <div style={{ width: modalData?.width ? modalData?.width : "" }} id={`${modalData?.position || "bottom"}-modal`} className={modalData?.toggle ? "" : "d-none"}>
                <div className="close-modal">
                    <span
                        onClick={() => {
                            setModalData({});
                        }}
                    >
                        &times;
                    </span>
                </div>
                {template}
            </div>
            <div
                id="modal-dark-bg"
                className={modalData?.toggle ? "" : "d-none"}
                onClick={() => {
                    setModalData({});
                }}
            ></div>
        </>
    );
};

export default Modal;
